module.exports = __webpack_public_path__ + "img/img01.80726d4b.png";